import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect } from 'react';
import { TwemojiWrapper } from '../../components/twemojiWrapper';
import { DEFAULT_FONT_FAMILY } from '../../constants/constants';
import { SubPageFooter } from './subPageFooter';
import { SubPageHeader } from './subPageHeader';
const CONTAINER_CSS = css `
  font-family: ${DEFAULT_FONT_FAMILY}, sans-serif;
  color: #aaaaaa;
`;
const CHILDREN_CONTAINER_CSS = css `
  max-width: 800px;
  padding: 20px 20px 60px 20px;
  margin: 0 auto;
`;
export const SubPageContainer = ({ title, children, omitHomeLink, omitExtraButtons }) => {
    useEffect(() => {
        document.title = `Triplejack Poker: ${title}`;
    }, [title]);
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(SubPageHeader, { title: title, omitHomeLink: omitHomeLink, omitExtraButtons: omitExtraButtons }), _jsx("article", { css: CHILDREN_CONTAINER_CSS, children: _jsx(TwemojiWrapper, { children: children }) }), _jsx(SubPageFooter, { omitExtraButtons: omitExtraButtons })] }));
};
